import React from 'react';
import ProtocolDaysEditor from '../ProtocolDaysEditor';
import styles from '../../../styles/mobileInfoPage.module.scss';

export default function ProtocolActivitiesStep({ formData, setFormData }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Dani i aktivnosti (nedeljni raspored)</h3>
      <p style={{ color: '#888', marginBottom: 16 }}>
        Ovaj nedeljni raspored (ponedeljak-nedelja) će se ponavljati dok se ne dostigne izabrano
        trajanje programa. Dani bez definisanih aktivnosti se preskaču — nije potrebno popuniti
        svaki dan.
      </p>
      <ProtocolDaysEditor
        value={formData.days}
        onChange={(daysOrUpdater) =>
          setFormData((prev) => ({
            ...prev,
            days:
              typeof daysOrUpdater === 'function'
                ? daysOrUpdater(prev.days)
                : daysOrUpdater,
          }))
        }
      />
    </section>
  );
}
